module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getIsShowingUpgradePlanPopup) ? _c('div', {
    staticClass: "background upgradePlanPopup d-flex flex-column align-items-center justify-content-center",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "popup radius-normal"
  }, [_c('div', {
    staticClass: "text-center fs-large darker bold p-4"
  }, [_vm._v("\n            Your current plan does not support this feature, please contact our team.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center p-4"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.pressOk
    }
  }, [_vm._v("Contact")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bd3e9c8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/other/UpgradePlanPopup.vue
// module id = 2112
// module chunks = 0